import { Component } from '@angular/core';

@Component({
    selector: 'app-nav-loading',
    templateUrl: './nav-loading.component.html',
    styleUrls: ['./nav-loading.component.scss'],
})
export class NavLoadingComponent {}
